import React from 'react';
import SingleScreeningResults from '../tables/SingleScreeningResults';
import MultiScreeningResults from '../tables/MultiScreeningResults';
import CircularProgress from '@mui/material/CircularProgress';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import AIEvalEntity from './AIEvalEntity';
import AIEvalProduct from './AIEvalProduct';
import SelectionsBadge from '../SelectionsBadge';
import { CustomLabel, CustomSwitch, ModuleContentTooltip } from 'components/Common/MUIStyledComponents';

interface ISearchProps {
  inputs: any;
  setInputs: any;
  handleSubmit: any;
  results: any;
  page: number;
  setPage: any;
  type: string;
  setShowFullRecord: any;
  userHasSearch: boolean;
  cyberTab: string | undefined;
  handleTabSwitch: any | undefined;
  cyberHeaders: string[];
  getCSVResults?: any;
  handleMultiPageChange?: any;
  aiSums?: any;
  state: any;
  openFilters?: any;
  openFiltersCode?: any;
  handleClear?: any;
  handleOpenDate?: any;
  handleSwitchChange?: any;
  createTicket?: any;
  saving?: boolean;
}

const Search: React.FC<ISearchProps> = ({ userHasSearch, setShowFullRecord, type, setPage, page, inputs, setInputs, handleSubmit, results, cyberTab, handleTabSwitch, cyberHeaders, getCSVResults, handleMultiPageChange, aiSums, state, openFilters, openFiltersCode, handleClear, handleOpenDate, handleSwitchChange, createTicket, saving }) => {
  const handleClearInput = (field: any) => {
    const onChangeValue = { ...inputs };
    onChangeValue[field] = '';
    setInputs(onChangeValue);
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const onChangeValue = { ...inputs };
    onChangeValue[name] = value;
    setInputs(onChangeValue);
  };

  return (
    <div className={`screening-search-container-full ${!userHasSearch ? 'os-iframe-blur' : ''}`}>
      {cyberTab && <div className='filters-tabs-container'>
        <div className='screening-tabs-inner'>
          <div className={`screening-tab-btn${cyberTab === 'CVE' ? '-selected' : ''}`} onClick={() => handleTabSwitch('CVE')}>
            <div className={`screening-tab-btn-text${cyberTab === 'CVE' ? '-selected' : ''}`}>
                Common Vulnerabilities & Exposures
            </div>
          </div>
          <div className={`screening-tab-btn${cyberTab === 'Markets' ? '-selected' : ''}`} onClick={() => handleTabSwitch('Markets')}>
            <div className={`screening-tab-btn-text${cyberTab === 'Markets' ? '-selected' : ''}`}>
                Notorious Markets
            </div>
          </div>
        </div>
      </div>}
      <div className='screening-inputs-list'>
        <div className='screening-input-row'>
          <div className='screening-label-input'>
            <div style={{ width: '-webkit-fill-available' }}>
              {type === 'Entities' ?
                <div className='screening-input-group' style={{ marginTop: 0 }}>
                  <div className='screening-input-field-container'>
                    <input
                      id='primary'
                      type='text'
                      placeholder='Required: Enter Person or Company Name'
                      className='screening-input-field-content'
                      name='primary'
                      value={inputs.primary}
                      onChange={(e) => handleChange(e)}
                      onKeyUp={(e) => {
                        if (e.key === 'Enter') {
                          handleSubmit(page);
                        }
                      }}
                    />
                    <svg onClick={() => handleClearInput('primary')} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                      <path d='M12 4L4 12M4 4L12 12' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg>
                  </div>
                  <div className='screening-input-minors'>
                    <div className='screening-input-field-container' style={{ width: '35%' }}>
                      <input
                        id='country'
                        type='text'
                        placeholder='Optional: Enter Country'
                        className='screening-input-field-content'
                        name='country'
                        value={inputs.country}
                        onChange={(e) => handleChange(e)}
                        onKeyUp={(e) => {
                          if (e.key === 'Enter') {
                            handleSubmit(page);
                          }
                        }}
                      />
                      <svg onClick={() => handleClearInput('country')} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                        <path d='M12 4L4 12M4 4L12 12' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                      </svg>
                    </div>
                    <div className='screening-input-field-container' style={{ width: '65%' }}>
                      <input
                        id='address'
                        type='text'
                        placeholder='Optional: Enter Address'
                        className='screening-input-field-content'
                        name='address'
                        value={inputs.address}
                        onChange={(e) => handleChange(e)}
                        onKeyUp={(e) => {
                          if (e.key === 'Enter') {
                            handleSubmit(page);
                          }
                        }}
                      />
                      <svg onClick={() => handleClearInput('address')} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                        <path d='M12 4L4 12M4 4L12 12' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                      </svg>
                    </div>
                  </div>
                </div> :

                type === 'Products' ?
                  <div className='screening-input-group' style={{ marginTop: 0 }}>
                    <div className='screening-input-minors'>
                      <div className='screening-input-field-container' style={{ width: '35%' }}>
                        <input
                          id='hsCode'
                          type='text'
                          placeholder='Enter HTS Code'
                          className='screening-input-field-content'
                          name='hsCode'
                          value={inputs.hsCode}
                          onChange={(e) => handleChange(e)}
                          onKeyUp={(e) => {
                            if (e.key === 'Enter') {
                              handleSubmit(page);
                            }
                          }}
                        />
                        <svg onClick={() => handleClearInput('hsCode')} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                          <path d='M12 4L4 12M4 4L12 12' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                        </svg>
                      </div>
                      <div className='screening-input-field-container' style={{ width: '65%' }}>
                        <input
                          id='desc'
                          type='text'
                          placeholder='Enter Product Name or Description'
                          className='screening-input-field-content'
                          name='desc'
                          value={inputs.desc}
                          onChange={(e) => handleChange(e)}
                          onKeyUp={(e) => {
                            if (e.key === 'Enter') {
                              handleSubmit(page);
                            }
                          }}
                        />
                        <svg onClick={() => handleClearInput('desc')} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                          <path d='M12 4L4 12M4 4L12 12' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                        </svg>
                      </div>
                    </div>
                    <div className='screening-input-minors'>
                      <div className='screening-input-field-container' style={{ width: '50%' }}>
                        <input
                          id='origin'
                          type='text'
                          placeholder='Optional: Enter Country of Origin'
                          className='screening-input-field-content'
                          name='origin'
                          value={inputs.origin}
                          onChange={(e) => handleChange(e)}
                          onKeyUp={(e) => {
                            if (e.key === 'Enter') {
                              handleSubmit(page);
                            }
                          }}
                        />
                        <svg onClick={() => handleClearInput('origin')} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                          <path d='M12 4L4 12M4 4L12 12' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                        </svg>
                      </div>
                      <div className='screening-input-field-container' style={{ width: '50%' }}>
                        <input
                          id='destination'
                          type='text'
                          placeholder='Optional: Enter Country of Destination'
                          className='screening-input-field-content'
                          name='destination'
                          value={inputs.destination}
                          onChange={(e) => handleChange(e)}
                          onKeyUp={(e) => {
                            if (e.key === 'Enter') {
                              handleSubmit(page);
                            }
                          }}
                        />
                        <svg onClick={() => handleClearInput('destination')} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                          <path d='M12 4L4 12M4 4L12 12' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                        </svg>
                      </div>
                    </div>
                  </div> :
                  <div className='screening-input-field-container'>
                    <input
                      id='cyber'
                      type='text'
                      className='screening-input-field-content'
                      placeholder='Required: Enter Value'
                      name='cyber'
                      value={inputs.cyber}
                      onChange={(e) => handleChange(e)}
                      onKeyUp={(e) => {
                        if (e.key === 'Enter') {
                          handleSubmit(page);
                        }
                      }}
                    />
                    <svg onClick={() => handleClearInput('cyber')} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                      <path d='M12 4L4 12M4 4L12 12' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg>
                  </div>
              }
            </div>
          </div>
        </div>
      </div>

      <div className='screening-filters-cont'>
        <div className='screening-filters-group'>
          {type !== 'Cyber' &&
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <ModuleContentTooltip
              title={
                <p className='module-header-tooltip-text'>
                      Utilize BITE Lens and select dates for when the data was added to narrow down your screening results.
                </p>
              }
              placement='top'
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    'display': 'flex',
                    'padding': 'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                    'flexDirection': 'column',
                    'alignItems': 'flex-start',
                    'alignSelf': 'stretch',
                    'borderRadius': 'var(--radius-md, 8px)',
                    'background': 'var(--Background-200, #202227)',
                    'maxWidth': '400px',
                    '& .MuiTooltip-arrow': {
                      color: 'var(--Background-200, #202227)'
                    }
                  },
                },
              }}
            >
              <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                <path d='M9 8.25C8.80109 8.25 8.61033 8.32902 8.46967 8.46967C8.32902 8.61032 8.25 8.80109 8.25 9V12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61033 12.671 8.80109 12.75 9 12.75C9.19892 12.75 9.38968 12.671 9.53033 12.5303C9.67099 12.3897 9.75 12.1989 9.75 12V9C9.75 8.80109 9.67099 8.61032 9.53033 8.46967C9.38968 8.32902 9.19892 8.25 9 8.25ZM9.285 5.31C9.10241 5.23499 8.8976 5.23499 8.715 5.31C8.62294 5.3457 8.53883 5.39922 8.4675 5.4675C8.40126 5.5404 8.34799 5.62411 8.31 5.715C8.26802 5.80401 8.24747 5.90162 8.25 6C8.24943 6.0987 8.26835 6.19655 8.30568 6.28793C8.343 6.37931 8.39799 6.46242 8.4675 6.5325C8.5404 6.59875 8.62412 6.65202 8.715 6.69C8.82863 6.73668 8.95198 6.75474 9.07421 6.74258C9.19645 6.73043 9.31383 6.68844 9.41604 6.6203C9.51825 6.55216 9.60215 6.45996 9.66039 6.3518C9.71862 6.24364 9.74939 6.12284 9.75 6C9.74724 5.80142 9.66955 5.61123 9.5325 5.4675C9.46118 5.39922 9.37707 5.3457 9.285 5.31ZM9 1.5C7.51664 1.5 6.0666 1.93987 4.83323 2.76398C3.59986 3.58809 2.63856 4.75943 2.07091 6.12987C1.50325 7.50032 1.35472 9.00832 1.64411 10.4632C1.9335 11.918 2.64781 13.2544 3.6967 14.3033C4.7456 15.3522 6.08197 16.0665 7.53683 16.3559C8.99168 16.6453 10.4997 16.4968 11.8701 15.9291C13.2406 15.3614 14.4119 14.4001 15.236 13.1668C16.0601 11.9334 16.5 10.4834 16.5 9C16.5 8.01509 16.306 7.03982 15.9291 6.12987C15.5522 5.21993 14.9997 4.39314 14.3033 3.6967C13.6069 3.00026 12.7801 2.44781 11.8701 2.0709C10.9602 1.69399 9.98492 1.5 9 1.5ZM9 15C7.81332 15 6.65328 14.6481 5.66658 13.9888C4.67989 13.3295 3.91085 12.3925 3.45673 11.2961C3.0026 10.1997 2.88378 8.99334 3.11529 7.82946C3.3468 6.66557 3.91825 5.59647 4.75736 4.75736C5.59648 3.91824 6.66558 3.3468 7.82946 3.11529C8.99335 2.88378 10.1997 3.0026 11.2961 3.45672C12.3925 3.91085 13.3295 4.67988 13.9888 5.66658C14.6481 6.65327 15 7.81331 15 9C15 10.5913 14.3679 12.1174 13.2426 13.2426C12.1174 14.3679 10.5913 15 9 15Z' fill='#F5FAFF'/>
              </svg>
            </ModuleContentTooltip>
            <button className='btn-new-automate' onClick={() => openFilters()}>
              <div>Set List Filters</div>
            </button>
            {type === 'Products' &&
            <button className='btn-new-automate' onClick={() => openFiltersCode()}>
              <div>Set HTS Code Filters</div>
            </button>}
            {state.lists.length > 0 && (
              <SelectionsBadge selections={state.lists} />
            )}
          </div>}


          <div className='filter-select-box' onClick={handleOpenDate}>
            <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
              <path d='M15.75 7.5H2.25M12 1.5V4.5M6 1.5V4.5M5.85 16.5H12.15C13.4101 16.5 14.0402 16.5 14.5215 16.2548C14.9448 16.039 15.289 15.6948 15.5048 15.2715C15.75 14.7902 15.75 14.1601 15.75 12.9V6.6C15.75 5.33988 15.75 4.70982 15.5048 4.22852C15.289 3.80516 14.9448 3.46095 14.5215 3.24524C14.0402 3 13.4101 3 12.15 3H5.85C4.58988 3 3.95982 3 3.47852 3.24524C3.05516 3.46095 2.71095 3.80516 2.49524 4.22852C2.25 4.70982 2.25 5.33988 2.25 6.6V12.9C2.25 14.1601 2.25 14.7902 2.49524 15.2715C2.71095 15.6948 3.05516 16.039 3.47852 16.2548C3.95982 16.5 4.58988 16.5 5.85 16.5Z' stroke='#EFF1F6' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
            <h2 className='filter-select-box-text'>Date</h2>
            {state.dateRange && state.dateRange.length > 0 && (
              <SelectionsBadge selections={[ '' ]} />
            )}
            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M9.17019 6.99981C8.98394 7.18717 8.87939 7.44062 8.87939 7.70481C8.87939 7.96899 8.98394 8.22244 9.17019 8.40981L12.7102 11.9998L9.17019 15.5398C8.98394 15.7272 8.87939 15.9806 8.87939 16.2448C8.87939 16.509 8.98394 16.7624 9.17019 16.9498C9.26315 17.0435 9.37375 17.1179 9.49561 17.1687C9.61747 17.2195 9.74818 17.2456 9.88019 17.2456C10.0122 17.2456 10.1429 17.2195 10.2648 17.1687C10.3866 17.1179 10.4972 17.0435 10.5902 16.9498L14.8302 12.7098C14.9239 12.6168 14.9983 12.5062 15.0491 12.3844C15.0998 12.2625 15.126 12.1318 15.126 11.9998C15.126 11.8678 15.0998 11.7371 15.0491 11.6152C14.9983 11.4934 14.9239 11.3828 14.8302 11.2898L10.5902 6.99981C10.4972 6.90608 10.3866 6.83169 10.2648 6.78092C10.1429 6.73015 10.0122 6.70401 9.88019 6.70401C9.74818 6.70401 9.61747 6.73015 9.49561 6.78092C9.37375 6.83169 9.26315 6.90608 9.17019 6.99981Z' fill='#EFF1F6'/>
            </svg>
          </div>

          <div className='filter-select-tooltip'>
            <h2>Entity Resolution?</h2>
            <ModuleContentTooltip
              title={
                <p className='module-header-tooltip-text'>
                      Entity Resolution is the ability to link records that have the same data in real life but may have a different spelling or formatting between the data sets being compared.
                </p>
              }
              placement='top'
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    'display': 'flex',
                    'padding': 'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                    'flexDirection': 'column',
                    'alignItems': 'flex-start',
                    'alignSelf': 'stretch',
                    'borderRadius': 'var(--radius-md, 8px)',
                    'background': 'var(--Background-200, #202227)',
                    'maxWidth': '400px',
                    '& .MuiTooltip-arrow': {
                      color: 'var(--Background-200, #202227)'
                    }
                  },
                },
              }}
            >
              <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                <path d='M9 8.25C8.80109 8.25 8.61033 8.32902 8.46967 8.46967C8.32902 8.61032 8.25 8.80109 8.25 9V12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61033 12.671 8.80109 12.75 9 12.75C9.19892 12.75 9.38968 12.671 9.53033 12.5303C9.67099 12.3897 9.75 12.1989 9.75 12V9C9.75 8.80109 9.67099 8.61032 9.53033 8.46967C9.38968 8.32902 9.19892 8.25 9 8.25ZM9.285 5.31C9.10241 5.23499 8.8976 5.23499 8.715 5.31C8.62294 5.3457 8.53883 5.39922 8.4675 5.4675C8.40126 5.5404 8.34799 5.62411 8.31 5.715C8.26802 5.80401 8.24747 5.90162 8.25 6C8.24943 6.0987 8.26835 6.19655 8.30568 6.28793C8.343 6.37931 8.39799 6.46242 8.4675 6.5325C8.5404 6.59875 8.62412 6.65202 8.715 6.69C8.82863 6.73668 8.95198 6.75474 9.07421 6.74258C9.19645 6.73043 9.31383 6.68844 9.41604 6.6203C9.51825 6.55216 9.60215 6.45996 9.66039 6.3518C9.71862 6.24364 9.74939 6.12284 9.75 6C9.74724 5.80142 9.66955 5.61123 9.5325 5.4675C9.46118 5.39922 9.37707 5.3457 9.285 5.31ZM9 1.5C7.51664 1.5 6.0666 1.93987 4.83323 2.76398C3.59986 3.58809 2.63856 4.75943 2.07091 6.12987C1.50325 7.50032 1.35472 9.00832 1.64411 10.4632C1.9335 11.918 2.64781 13.2544 3.6967 14.3033C4.7456 15.3522 6.08197 16.0665 7.53683 16.3559C8.99168 16.6453 10.4997 16.4968 11.8701 15.9291C13.2406 15.3614 14.4119 14.4001 15.236 13.1668C16.0601 11.9334 16.5 10.4834 16.5 9C16.5 8.01509 16.306 7.03982 15.9291 6.12987C15.5522 5.21993 14.9997 4.39314 14.3033 3.6967C13.6069 3.00026 12.7801 2.44781 11.8701 2.0709C10.9602 1.69399 9.98492 1.5 9 1.5ZM9 15C7.81332 15 6.65328 14.6481 5.66658 13.9888C4.67989 13.3295 3.91085 12.3925 3.45673 11.2961C3.0026 10.1997 2.88378 8.99334 3.11529 7.82946C3.3468 6.66557 3.91825 5.59647 4.75736 4.75736C5.59648 3.91824 6.66558 3.3468 7.82946 3.11529C8.99335 2.88378 10.1997 3.0026 11.2961 3.45672C12.3925 3.91085 13.3295 4.67988 13.9888 5.66658C14.6481 6.65327 15 7.81331 15 9C15 10.5913 14.3679 12.1174 13.2426 13.2426C12.1174 14.3679 10.5913 15 9 15Z' fill='#F5FAFF'/>
              </svg>
            </ModuleContentTooltip>
          </div>
          <CustomLabel
            control={<CustomSwitch checked={state.fuzzy} onChange={handleSwitchChange} name='fuzzy' />}
            label={state.fuzzy ? 'Yes' : 'No'}
          />


          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginLeft: 'auto' }}>
            <ModuleContentTooltip
              title={
                type === 'Entities' ? (
                  <p className='module-header-tooltip-text'>
                    Enter a person or company name to be screened on the BITE data lists. <br/><br/> you may enter a country or address to increase the accuracy of your evaluation.
                  </p>
                ) : (
                  <p className='module-header-tooltip-text'>
                    Enter a product name or HTS Code to be screened on the BITE data lists, you may enter country information for a more accurate evaluation of your screen. <br/><br/> If both HTS Code and Descritption are entered the HTS Code will be searched. <br/><br/> If you do not know your HTS Code you may use our <Link to='/bite-classify'>
                      <Button sx={{ color: '#4895EF', padding: 0 }}>BITE Classify Tool</Button>
                    </Link>
                  </p>
                )
              }
              placement='top'
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    'display': 'flex',
                    'padding': 'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                    'flexDirection': 'column',
                    'alignItems': 'flex-start',
                    'alignSelf': 'stretch',
                    'borderRadius': 'var(--radius-md, 8px)',
                    'background': 'var(--Background-200, #202227)',
                    'maxWidth': '400px',
                    '& .MuiTooltip-arrow': {
                      color: 'var(--Background-200, #202227)'
                    }
                  },
                },
              }}
            >
              <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                <path d='M9 8.25C8.80109 8.25 8.61033 8.32902 8.46967 8.46967C8.32902 8.61032 8.25 8.80109 8.25 9V12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61033 12.671 8.80109 12.75 9 12.75C9.19892 12.75 9.38968 12.671 9.53033 12.5303C9.67099 12.3897 9.75 12.1989 9.75 12V9C9.75 8.80109 9.67099 8.61032 9.53033 8.46967C9.38968 8.32902 9.19892 8.25 9 8.25ZM9.285 5.31C9.10241 5.23499 8.8976 5.23499 8.715 5.31C8.62294 5.3457 8.53883 5.39922 8.4675 5.4675C8.40126 5.5404 8.34799 5.62411 8.31 5.715C8.26802 5.80401 8.24747 5.90162 8.25 6C8.24943 6.0987 8.26835 6.19655 8.30568 6.28793C8.343 6.37931 8.39799 6.46242 8.4675 6.5325C8.5404 6.59875 8.62412 6.65202 8.715 6.69C8.82863 6.73668 8.95198 6.75474 9.07421 6.74258C9.19645 6.73043 9.31383 6.68844 9.41604 6.6203C9.51825 6.55216 9.60215 6.45996 9.66039 6.3518C9.71862 6.24364 9.74939 6.12284 9.75 6C9.74724 5.80142 9.66955 5.61123 9.5325 5.4675C9.46118 5.39922 9.37707 5.3457 9.285 5.31ZM9 1.5C7.51664 1.5 6.0666 1.93987 4.83323 2.76398C3.59986 3.58809 2.63856 4.75943 2.07091 6.12987C1.50325 7.50032 1.35472 9.00832 1.64411 10.4632C1.9335 11.918 2.64781 13.2544 3.6967 14.3033C4.7456 15.3522 6.08197 16.0665 7.53683 16.3559C8.99168 16.6453 10.4997 16.4968 11.8701 15.9291C13.2406 15.3614 14.4119 14.4001 15.236 13.1668C16.0601 11.9334 16.5 10.4834 16.5 9C16.5 8.01509 16.306 7.03982 15.9291 6.12987C15.5522 5.21993 14.9997 4.39314 14.3033 3.6967C13.6069 3.00026 12.7801 2.44781 11.8701 2.0709C10.9602 1.69399 9.98492 1.5 9 1.5ZM9 15C7.81332 15 6.65328 14.6481 5.66658 13.9888C4.67989 13.3295 3.91085 12.3925 3.45673 11.2961C3.0026 10.1997 2.88378 8.99334 3.11529 7.82946C3.3468 6.66557 3.91825 5.59647 4.75736 4.75736C5.59648 3.91824 6.66558 3.3468 7.82946 3.11529C8.99335 2.88378 10.1997 3.0026 11.2961 3.45672C12.3925 3.91085 13.3295 4.67988 13.9888 5.66658C14.6481 6.65327 15 7.81331 15 9C15 10.5913 14.3679 12.1174 13.2426 13.2426C12.1174 14.3679 10.5913 15 9 15Z' fill='#F5FAFF'/>
              </svg>
            </ModuleContentTooltip>
            {type === 'Products' && (inputs.hsCode.length < 1 && inputs.desc.length < 1) ?
              <div className='screening-input-submit-group'>
                <button className='btn-new-automate-disabled'>
                  <div>Run Screen</div>
                </button>
              </div> :
              <div className='screening-input-submit-group'>
                <button className='btn-new-automate' onClick={() => handleSubmit(page)}>
                  <div>Run Screen</div>
                </button>
              </div>

            }
          </div>
        </div>
      </div>

      {results.isLoading && (
        <div>
          <CircularProgress style={{ color: '#0E8BFF' }} />
        </div>
      )}
      { (!results.isLoading && type === 'Entities') &&
        <AIEvalEntity
          aiSums={aiSums}
        />
      }
      {/* { (!results.isLoading && type === 'Products') &&
        <AIEvalProduct
          aiSums={aiSums}
        />
      } */}
      {!results.isLoading && results.data.length === 1 && (type === 'Cyber' || !results.data[0]?.result?.body?.hits?.hits[0]?.matched_queries) && (
        <SingleScreeningResults setShowFullRecord={setShowFullRecord} type={type} handleSubmit={handleSubmit} setPage={setPage} page={page} results={results} cyberHeaders={cyberHeaders} getCSVResults={getCSVResults} />
      )}
      {!results.isLoading && results.data.length > 0 && results.data[0]?.result?.body?.hits?.hits[0]?.matched_queries?.length > 0 && !(type === 'Cyber') && (
        <MultiScreeningResults setShowFullRecord={setShowFullRecord} type={type} handleSubmit={handleSubmit} inputs={inputs} setPage={setPage} page={page} results={results} cyberHeaders={cyberHeaders} handleMultiPageChange={handleMultiPageChange} createTicket={createTicket} saving={saving}/>
      )}
    </div>
  );
};

export default Search;
